module.exports = __webpack_public_path__ + "static/media/delete-define-piece.502725d5.png";